'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { AlertModal } from './AlertModal';
import { useContext, useRef } from 'react';
import { AlertContext } from './AlertContext';
import AlertControl from './AlertControl';
const componentMap = {
    modal: AlertModal
};
export const AlertConductor = ({ placement }) => {
    const { current: Component } = useRef(componentMap[placement] || AlertControl);
    const { useAlerts, removeAlert } = useContext(AlertContext);
    const alerts = useAlerts(placement);
    const displayAlert = alerts?.[0] || null;
    const { container: containerSyles, ...sx } = styles[placement] || {};
    return (_jsx(Box, { sx: containerSyles, children: displayAlert && (_jsx(Component, { sx: sx, ...displayAlert, onClick: () => removeAlert(displayAlert.id) })) }));
};
const styles = {
    banner: {
        container: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999
        },
        root: {
            borderRadius: 0
        }
    },
    toast: {
        container: {
            position: 'fixed',
            bottom: 24,
            left: 24,
            width: 300,
            zIndex: 9999
        },
        root: {}
    },
    modal: {}
};
